import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Field } from 'redux-form'
import Mixin from 'components/common/Mixin'
import { VEHICLE_SELECTOR_TARGET_ID } from 'constant'
import UpdatingBlock from 'components/common/UpdatingBlock/UpdatingBlock'
import VehicleSelectorButtonGroup from './VehicleSelectorButtonGroup'
import Section from '../Section'
import model from '../viewModel'

const BOTVehicleSelector = ({
  icon,
  question,
  title,
  isTrailer,
  setIsTrailer,
  makeActiveVehicle,
  noHeading,
  setAppointmentActiveVehicle,
  setVehicleSelectorIsLoading,
  vehicleSelectorIsLoading,
  vehicles = []
}) =>
  <Fragment>
    <Section
      asset={ icon }
      title={ title }
      subhead={ question }
      targetId={ VEHICLE_SELECTOR_TARGET_ID }
      noHeading={ noHeading }>
      <UpdatingBlock condition={ vehicleSelectorIsLoading }>
        <VehicleWrapper>
          <Field
            { ...model.vehicleSelector }
            vehicles={ vehicles }
            isTrailer={ isTrailer }
            handleTrailerChange={ setIsTrailer }
            makeActiveVehicle={ makeActiveVehicle }
            setAppointmentActiveVehicle={ setAppointmentActiveVehicle }
            setVehicleSelectorIsLoading={ setVehicleSelectorIsLoading }
            component={ VehicleSelectorButtonGroup } />
        </VehicleWrapper>
      </UpdatingBlock>
    </Section>
  </Fragment>

BOTVehicleSelector.propTypes = {
  icon: PropTypes.string,
  isTrailer: PropTypes.bool,
  makeActiveVehicle: PropTypes.func,
  noHeading: PropTypes.bool,
  question: PropTypes.string,
  setAppointmentActiveVehicle: PropTypes.func,
  setIsTrailer: PropTypes.func,
  setVehicleSelectorIsLoading: PropTypes.func,
  title: PropTypes.string,
  vehicles: PropTypes.arrayOf(PropTypes.shape()),
  vehicleSelectorIsLoading: PropTypes.bool
}

export default BOTVehicleSelector

const VehicleWrapper = styled.div`
  ${Mixin.responsive('margin', '0 -12px', '0 -8px')}
`
